import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import {
  RWD_XL,
  RWD_LG,
  RWD_MD,
  RWD_SM,
  RWD_SS,
  RWD_XS,
} from "../../utils/rwd";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Wrapper = styled.div`
  width: 100%;
  background-color: #3a3d5a;
  border-radius: 8px;
  padding: 10px;
  height: 460px;
  ${RWD_MD(css`
    height: 30vh;
  `)};
`;

const MiningLineChart = ({ chartData = [], chartLabel = [], chartName }) => {
  const [options, setOptions] = useState({});
  
  useEffect(() => {
    const baseOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          ticks: {
            color: "#fcfcfc",
          },
        },
        y: {
          ticks: {
            color: "#fcfcfc",
            callback: function (value) {
              return `${Math.round(value)} % `;
            },
          },
        },
      },
      plugins: {
        legend: { 
          labels: {
            color: "orange",
          },
        },
        title: {
          display: true,
          text: chartName,
          color: "#fcfcfc",
        },
      },
    };

    // 手機版
    if (window.innerWidth < 768) {
      baseOptions.scales.x.ticks.font = { size: 8 };
      baseOptions.scales.y.ticks.font = { size: 8 };
      baseOptions.plugins.legend.labels.boxWidth = 8;
      baseOptions.plugins.legend.labels.font = { size: 10 };
      baseOptions.plugins.title.font = { size: 14 };
    } else {
      // 桌面版
      baseOptions.scales.x.ticks.font = { size: 12 };
      baseOptions.scales.y.ticks.font = { size: 12 };
      baseOptions.plugins.legend.labels.boxWidth = 45;
      baseOptions.plugins.legend.labels.font = { size: 14 };
      baseOptions.plugins.title.font = { size: 18 };
    }
    
    setOptions(baseOptions);
    
    // 添加窗口大小變化監聽器以處理響應式
    const handleResize = () => {
      const newOptions = { ...baseOptions };
      
      if (window.innerWidth < 768) {
        newOptions.scales.x.ticks.font = { size: 8 };
        newOptions.scales.y.ticks.font = { size: 8 };
        newOptions.plugins.legend.labels.boxWidth = 8;
        newOptions.plugins.legend.labels.font = { size: 10 };
        newOptions.plugins.title.font = { size: 14 };
      } else {
        newOptions.scales.x.ticks.font = { size: 12 };
        newOptions.scales.y.ticks.font = { size: 12 };
        newOptions.plugins.legend.labels.boxWidth = 12;
        newOptions.plugins.legend.labels.font = { size: 14 };
        newOptions.plugins.title.font = { size: 18 };
      }
      
      setOptions(newOptions);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [chartName]); 

  const borderColor = [
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
    "rgba(75, 192, 192, 1)",
  ];

  const backgroundColor = [
    "rgba(255, 99, 132, 1)",
    "rgba(54, 162, 235, 1)",
    "rgba(255, 206, 86, 1)",
    "rgba(75, 192, 192, 1)",
  ];

  const calculator = (arr) => {
    return arr.map((data, index, array) => {
      let subArray = array.slice(0, index + 1);
      let sum = subArray.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );

      return sum;
    });
  };

  const data = {
    labels: chartLabel,
    datasets: chartData.map((item, index) => {
      return {
        label: item.Target,
        data: calculator(item.ProfitPercent.map((profit) => profit * 100)),
        borderColor: borderColor[index],
        backgroundColor: backgroundColor[index],
        borderWidth: 1,
        pointRadius: 2,
      };
    }),
  };

  return (
    <Wrapper>
      <Line options={options} data={data} /> 
    </Wrapper>
  );
};

export default MiningLineChart;